import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import { C } from '../theme';

/** Full-screen hold while the stored token is being verified. */
export const AuthGate: React.FC = () => (
  <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', bgcolor: C.bg }}>
    <CircularProgress size={28} sx={{ color: C.ink3 }} />
  </Box>
);

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <AuthGate />;
  return user ? <>{children}</> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
